import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  DownloadMultipleClientsDataInExcel,
  FilterJsonExactlyMatching,
  getEndOfMonth,
  getStartOfMonth,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
function ContractorView() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);

  const [moversList, setMoversList] = useState<any>([]);
  const [rateTypeData, setRateTypeData] = useState<any>([]);
  const [totalsData, setTotalsData] = useState<any>([]);
  const [employeeJobData, setEmployeeJobData] = useState<any>([]);
  const [employeeBonusAndDeductionsData, setEmployeeBonusAndDeductionsData] =
    useState<any>([]);
  const [employeeReviewData, setEmployeeReviewData] = useState<any>([]);
  
    const [showModal, setShowModal] = useState(false);
  const [EarningsDetails, setEarningsDetails] = useState<any>([]);
    const [isEarning, setIsEarning] = useState(true);
  
const [tippingObject, setTippingObject] = useState<any>({
    EndDate: getEndOfMonth(),
    JobID: "",
    MNVMoverID: AppContext.MNVMoverID,
    StartDate: getStartOfMonth(),
    EarningsView: true,
    Total: 0,
  });

  const [filterData, setFilterData] = useState({
    StartDate: new Date().getFullYear(),
    EndDate: new Date().getMonth() + 1,
    StartMonth: new Date().getMonth() + 1,
    MNVMoverID: AppContext.MNVMoverID,
    ShowJobData: true,
    ShowBonusAndDeductionsData: false,
    ShowReviewsData: false,
    IsFirstTime: true,
  });



  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: getStartOfMonth(),
    EndDate: getEndOfMonth(),
  });

  useEffect(() => {
    getJobReviewGetJobDetailsAndMoversList(1);
  }, []);

  useEffect(() => {
    if (filterData.MNVMoverID > 0 && filterData.IsFirstTime) {
      setFilterData((prevState: any) => ({
        ...prevState,
        IsFirstTime: false,
      }));
      MNVMoverJobDataGetContractorViewData();
    }
  }, [filterData]);

  function getJobReviewGetJobDetailsAndMoversList(typeid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.typeid = typeid;
    object.screenname = "employeebonusanddeductions";
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVJobReview/MNVJobReviewGetJobDetailsAndMoversList",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          if (typeid == 1) {
            let filtered = l_oResponse[1].filter(
              (item: any) => item.IsContractor == true
            );
            setMoversList(filtered);
            if (filtered.length > 0 && AppContext.MNVMoverID == 0) {
              setFilterData((prevState: any) => ({
                ...prevState,
                MNVMoverID: filtered[0]["MNVMoverID"],
              }));
            }
            else {
              setFilterData((prevState: any) => ({
                ...prevState,
                MNVMoverID: AppContext.MNVMoverID,
              }));
            }
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVMoverJobDataGetContractorViewData() {
    setIsAnimation(true);
    setIsEarning(true);
    let object = {} as any;
    object.mnvmoverid = filterData.MNVMoverID;
    object.startdate = moment(FilterObjectObject.StartDate).format("YYYY-MM-DD");
    object.enddate = moment(FilterObjectObject.EndDate).format("YYYY-MM-DD");
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVMoverJobData/MNVMoverJobDataGetContractorViewData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          // setRateTypeData(l_oResponse[0]);
          // setTotalsData(l_oResponse[1]);
          // setEmployeeJobData(l_oResponse[2]);
          // setEmployeeBonusAndDeductionsData(l_oResponse[3]);
          // setEmployeeReviewData(l_oResponse[4]);

          // console.log("full response:", l_oResponse);
          // console.log("index 4:", l_oResponse[4]);

          setRateTypeData(l_oResponse[0]);
          setTotalsData(l_oResponse[1]);
          setEmployeeJobData(l_oResponse[1]);
          setEmployeeBonusAndDeductionsData(l_oResponse[2]);
          setEmployeeReviewData(l_oResponse[3]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  
  const MNVQuoteGetMoverEarningDetail = (
    p_intMNVQuoteID: any,
    p_intMNVMoverID: any,
    p_boolIsLocalQuote: any,
    p_intRoleID: any
  ) => {
    let data = {} as any;
    data.MNVQuoteID = p_intMNVQuoteID;
    data.MNVMoverID = p_intMNVMoverID;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetMoverEarningDetail",
        data
      )
      .then((result) => {
        setIsAnimation(false);
        let thisEarningsDetails: any = result.data[0];

        thisEarningsDetails = FilterJsonExactlyMatching(
          thisEarningsDetails,
          "RoleID",
          p_intRoleID
        );

        tippingObject.MoverTotal = 0;
        for (var i = 0; i < thisEarningsDetails.length; i++) {
          if (
            !p_boolIsLocalQuote &&
            thisEarningsDetails[i]["MNVQuoteDetailTypeID"] <= 5
          ) {
            var l_intTotalMinutes = thisEarningsDetails[i]["Quantity"] * 60;
            var l_intTotalHours = Math.floor(l_intTotalMinutes / 60);
            var l_intRemainingMinutes = parseInt(
              (l_intTotalMinutes % 60).toString()
            );

            var l_strHoursText = "hour";
            if (l_intTotalHours > 1) l_strHoursText = "hours";

            var l_strMinutesText = "minute";
            if (l_intRemainingMinutes > 1) l_strMinutesText = "minutes";

            if (l_intTotalHours > 0 && l_intRemainingMinutes > 0)
              thisEarningsDetails[i]["QuantityText"] =
                l_intTotalHours +
                " " +
                l_strHoursText +
                ", " +
                l_intRemainingMinutes +
                " " +
                l_strMinutesText;
            else if (l_intTotalHours > 0)
              thisEarningsDetails[i]["QuantityText"] =
                l_intTotalHours + " " + l_strHoursText;
            else
              thisEarningsDetails[i]["QuantityText"] =
                l_intRemainingMinutes + " " + l_strMinutesText;
          }

          if (thisEarningsDetails[i]["MNVMoverID"] != p_intMNVMoverID) {
            thisEarningsDetails.splice(i, 1);
            i--;
          }else {
            tippingObject.MoverTotal += thisEarningsDetails[i]["Amount"];
          }
        }
        setEarningsDetails(thisEarningsDetails);
        setShowModal(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [rates, setRates] = useState<any[]>([]);

  const MNVMoverRatesGetCompleteGridData = async () => {
    try {
      let obj = {} as any;
      obj.MoverID = AppContext.MNVMoverID > 0 ? AppContext.MNVMoverID:filterData.MNVMoverID;
      setIsAnimation(true);

      const { data } = await axiosAuth.post(
        `${AppContext.APIURL}api/MNVMoverRates/MNVMoverRatesGetCompleteGridDataCustomAdmin`,
        obj
      );
      setRates(data.Data?.[0] ?? []);
      setIsAnimation(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsAnimation(false);
    }
  };

  function getSelectedMNVMoverName() {
    let filtered = moversList.filter(
      (item: any) => item.MNVMoverID == filterData.MNVMoverID
    );
    if (filtered.length > 0) return filtered[0].Name;
    else return "Employee";
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <>
        <div className="flex-d justify-btw mb-10 m-f-wrap1">
          <div className="flex-da gap-10 m-f-wrap2">
            {AppContext.MNVMoverID == 0 && AppContext.IsAdmin && (
              <div className="field-input">
                <select
                  className="input-field width-auto"
                  value={filterData.MNVMoverID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      MNVMoverID: e.target.value,
                    }));
                  }}
                >
                  {moversList &&
                    moversList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.MNVMoverID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
            )}

            <div className="field-input grid-d flex-gap3 date-field">
              <span className="font-12 text-left label-color"></span>
              <input
                type="Date"
                className="input-field w-100"
                value={moment(FilterObjectObject.StartDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  const selectedDate = moment(e.target.value);
                  setFilterObjectObject((prevState: any) => ({
                    ...prevState,
                    StartDate: selectedDate.format("YYYY-MM-DD"),
                  }));
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    StartMonth: selectedDate.month() + 1,
                  }));
                }}
              />
            </div>
            <div className="field-input grid-d flex-gap3 date-field">
              <span className="font-12 text-left label-color"></span>
              <input
                type="Date"
                className="input-field w-100"
                value={moment(FilterObjectObject.EndDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  const selectedDate = moment(e.target.value);
                  setFilterObjectObject((prevState: any) => ({
                    ...prevState,
                    EndDate: selectedDate.format("YYYY-MM-DD"),
                  }));
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    EndDate: selectedDate.month() + 1,
                  }));
                }}
              />
            </div>

            <div className="flex-daj btn-start">
              <a
                className="btn-primary flex-daj"
                onClick={() => MNVMoverJobDataGetContractorViewData()}
              >
                Filter
              </a>
            </div>
          </div>
          <div className="flex-d gap-10 m-f-wrap3">
            {/* <a
              className="btn-primary flex-daj btn-grid"
              title="Export Job Type Hours"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "Job_Type_Hours",
                  "Job Type Hours " + filterData.StartDate+ "-"+ AppContext.monthsList[filterData.EndDate-1].Name
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>


            <a
              className="btn-primary flex-daj btn-grid"
              title="Export Totals"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "Totals",
                  "Totals " + filterData.StartDate+ "-"+ AppContext.monthsList[filterData.EndDate-1].Name
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a> */}

            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Job_Type_Hours",
                  getSelectedMNVMoverName() +
                  "_" +
                  AppContext.monthsList[filterData.StartMonth - 1].Name +
                  "-" +
                  AppContext.monthsList[filterData.EndDate - 1].Name +
                  "-" +
                  filterData.StartDate
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export All Tables"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Job_Type_Hours,Job_Data,Bonus_And_Deduction,Review_And_SocialMedia_Data",
                  getSelectedMNVMoverName() +
                  "_" +
                  AppContext.monthsList[filterData.StartMonth - 1].Name +
                  "-" +
                  AppContext.monthsList[filterData.EndDate - 1].Name +
                  "-" +
                  filterData.StartDate
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>

        <div className="grid-d fr-111 gap-20 flex-as c-view">
          <div className="flow-auto no-display">
            <table className="reuse-table" id="Job_Type_Hours">
              <thead>
                <tr>
                  <th>Hours Worked</th>
                  <th>Days Worked</th>
                  <th>Jobs Attended</th>
                  <th>Stairs Climbed</th>
                  <th>Reviews</th>
                  <th>Social</th>
                  <th>Subtotal for Jobs</th>
                  <th>Bonus & Deduction</th>
                  <th>Review & Social</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {rateTypeData &&
                  rateTypeData.map((item: any, index: any) => (
                    <React.Fragment key={"emp" + index}>
                      <tr key={index}>
                        <td>{item.HoursWorked} {" "}Hrs</td>
                        <td className="text-right">{item.DaysWorked}{" "}Days</td>
                        <td className="text-right">{item.JobsAttended}{" "}Jobs</td>
                        <td className="text-right">{item.StairsClimbed}</td>
                        <td className="text-right">{item.Reviews}</td>
                        <td className="text-right">{item.SocialMedia}</td>
                        <td className="text-right">
                          £
                          {item.SubtotalJobs?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">
                          £
                          {item.BonusAndDeduction?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">
                          £
                          {item.ReviewAndSocialBonus?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">
                          £
                          {item.Total?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>

          {rateTypeData &&
            rateTypeData.map((item: any, index: any) => (
              <React.Fragment key={"emp" + index}>
                <div key={index} className="grid-d flex-gap10">
                  <div className="data-boxes">
                    <span className="data-txt">Hours Worked:</span>
                    <span>{item.HoursWorked}{" "}Hrs</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Days Worked:</span>
                    <span>{item.DaysWorked}{" "}Days</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Jobs Attended:</span>
                    <span>{item.JobsAttended}{" "}Jobs</span>
                  </div>
                </div>
              </React.Fragment>
            ))}

          {rateTypeData &&
            rateTypeData.map((item: any, index: any) => (
              <React.Fragment key={"emp" + index}>
                <div key={index} className="grid-d flex-gap10">
                  <div className="data-boxes">
                    <span className="data-txt">Stairs Climbed:</span>
                    <span>{item.StairsClimbed}</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Reviews:</span>
                    <span>{item.Reviews}</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Social:</span>
                    <span>{item.SocialMedia}</span>
                  </div>
                </div>
              </React.Fragment>
            ))}

          {rateTypeData &&
            rateTypeData.map((item: any, index: any) => (
              <React.Fragment key={"emp" + index}>
                <div key={index} className="grid-d flex-gap10">
                  <div className="data-boxes">
                    <span className="data-txt">Subtotal Jobs:</span>
                    <span>£
                      {item.SubtotalJobs?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Bonus & Deduction:</span>
                    <span>£
                      {item.BonusAndDeduction?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Review & Social:</span>
                    <span>£
                      {item.ReviewAndSocialBonus?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</span>
                  </div>
                  <div className="data-boxes">
                    <span className="data-txt">Total:</span>
                    <span>£
                      {item.Total?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</span>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </div>

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowJobData = !filterDataLocal.ShowJobData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowJobData: filterDataLocal.ShowJobData,
            }));
          }}
        >
          Job Data
          <img
            className={`name-count ${filterData.ShowJobData ? "rotate-90n" : "rotate-90"
              }`}
            src="/images/chev-right-w.svg"
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowJobData && ( */}
        <span className={filterData.ShowJobData ? "" : "no-display"}>
          <div className="flex-d justify-end mb-10 gap-10">

<div className="flex-da flex-gap10">          
            <div className="flex-d">
              <div className="copy-tab copy-tab2 copy-tab3">
                <a
                  className={`${isEarning ? "selected" : ""}`}
                  onClick={() => setIsEarning(true)}
                >
                  Earnings
                </a>

                <a
                  className={`${!isEarning ? "selected" : ""}`}
                  onClick={() => {
                    setIsEarning(false);
                    MNVMoverRatesGetCompleteGridData();
                  }}
                >
                  Rates
                </a>
              </div>
            </div>
        </div>

            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  isEarning ? "Job_Data" : "tblmoverrates",
                  getSelectedMNVMoverName() +
                  "_" +
                  AppContext.monthsList[filterData.StartMonth - 1].Name +
                  "-" +
                  AppContext.monthsList[filterData.EndDate - 1].Name +
                  "-" +
                  filterData.StartDate
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            {isEarning &&
            <table className="reuse-table" id="Job_Data">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Role</th>
                  <th>Job ID</th>
                  <th>PostCodes</th>
                  <th>Type</th>
                  <th>Amount</th>
                <th className="reuse-tdxs"></th>
                </tr>
              </thead>
              <tbody>
                {employeeJobData &&
                  employeeJobData.map((item: any, index: any) => (
                    <React.Fragment key={"emp" + index}>
                      <tr key={index}>
                        <td>{moment(item.RequestedDate).format("DD/MM/YYYY")}</td>
                        <td>{item.RoleName}</td>
                        <td>{item.JobID}</td>
                        <td>{item.FromPostalCode} - {item.ToPostalCode}</td>
                        <td>{item.IsLocalQuote === true ? "Local" : "Long"}</td>
                        <td className="text-right">
                          £
                          {item.Amount?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-center">
                        <div className="flex-daj gap-10">
                          <a
                            title="Details"
                            onClick={() => {
                              MNVQuoteGetMoverEarningDetail(
                                item.MNVQuoteID,
                                item.MNVMoverID,
                                item.IsLocalQuote,
                                item.RoleID
                              );
                            }}
                          >
                            <img
                              src="images/info-red.svg"
                              width="18px"
                              height="18px"
                              alt="split"
                            />
                          </a>
                        </div>
                      </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
}

      {isEarning == false && (
        <>
          <>
            <div className="flow-auto mt-10">
              <table className="reuse-table" id="tblmoverrates">
                <thead>
                  <tr>
                    <th>Van</th>
                    <th>Type</th>
                    <th>Tier</th>
                    <th className="text-right">DTP / Mile</th>
                    <th className="text-right">PTD / Mile</th>
                    <th className="text-right">DTD / Mile</th>
                    <th className="text-right">Local / Hour</th>
                    <th className="text-right">Long / Hour</th>
                    <th className="text-right">Long / Mile</th>
                    <th className="text-right">Per Stair Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {rates?.map((row, index) => (
                    <tr key={index}>
                      <td>{row.DTDPerHourRateName}</td>
                      <td>{row.PTDPerHourRateName}</td>
                      <td className="text-right">{row.Name}</td>

                      <td className="text-right">
                        £
                        {Number(row.DTPPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.PTDPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.DTDPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.LocalMovePerHourRate)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.DTPPerHourRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(
                          row.LoadingUnloadingPerHourRate
                        )?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.PerStairRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        </>
      )}
          </div>
        </span>
        {/* )} */}

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowBonusAndDeductionsData =
              !filterDataLocal.ShowBonusAndDeductionsData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowBonusAndDeductionsData:
                filterDataLocal.ShowBonusAndDeductionsData,
            }));
          }}
        >
          Bonus And Deductions
          <img
            src="/images/chev-right-w.svg"
            className={`name-count ${filterData.ShowBonusAndDeductionsData ? "rotate-90n" : "rotate-90"
              }`}
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowBonusAndDeductionsData && ( */}
        <span
          className={filterData.ShowBonusAndDeductionsData ? "" : "no-display"}
        >
          <div className="flex-d justify-end mb-10 gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Bonus_And_Deduction",
                  getSelectedMNVMoverName() +
                  "_" +
                  AppContext.monthsList[filterData.StartMonth - 1].Name +
                  "-" +
                  AppContext.monthsList[filterData.EndDate - 1].Name +
                  "-" +
                  filterData.StartDate
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="Bonus_And_Deduction">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>More Information</th>
                </tr>
              </thead>
              <tbody>
                {employeeBonusAndDeductionsData &&
                  employeeBonusAndDeductionsData.map(
                    (item: any, index: any) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>{moment(item.DataDate).format("DD/MM/YYYY")}</td>
                          <td>{item.DataTypeName}</td>
                          <td className="text-right">
                            £
                            {item.Amount?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td>{item.Reason}</td>
                        </tr>
                      </React.Fragment>
                    )
                  )}
              </tbody>
            </table>
          </div>
        </span>
        {/* )} */}

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowReviewsData = !filterDataLocal.ShowReviewsData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowReviewsData: filterDataLocal.ShowReviewsData,
            }));
          }}
        >
          Reviews & Social Media Data
          <img
            src="/images/chev-right-w.svg"
            className={`name-count ${filterData.ShowReviewsData ? "rotate-90n" : "rotate-90"
              }`}
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowReviewsData && ( */}
        <span className={filterData.ShowReviewsData ? "" : "no-display"}>
          <div className="flex-d justify-end mb-10 gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Review_And_SocialMedia_Data",
                  getSelectedMNVMoverName() +
                  "_" +
                  AppContext.monthsList[filterData.StartMonth - 1].Name +
                  "-" +
                  AppContext.monthsList[filterData.EndDate - 1].Name +
                  "-" +
                  filterData.StartDate
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="Review_And_SocialMedia_Data">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {employeeReviewData &&
                  employeeReviewData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td>{item.CategoryName}</td>
                        <td className="text-right">{moment(item.ReviewDate).format("DD/MM/YYYY")}</td>
                        <td className="text-right">
                          £
                          {item.Amount?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </span>
        {/* )} */}
      </>
    
    
      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner md-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Details</h3>
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="flow-auto-lg mt-10">
                <table className="reuse-table">
                  <thead>
                    <tr>
                      <th className="reuse-tdxs"></th>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Rate</th>
                      <th className="text-right">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {EarningsDetails.map((Row: any, index: any) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{Row.Name}</td>

                        {!Row.QuantityText && (
                          <td className="text-right">
                            {Number(Row.Quantity)?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        )}

                        {Row.QuantityText && <td>{Row.QuantityText}</td>}

                        <td className="text-right">
                          £
                          {Number(Row.Rate)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        <td className="text-right">
                          £
                          {Number(Row.Amount)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td></td>
                      <td>
                        <b>Total</b>
                      </td>
                      <td></td>
                      <td></td>
                      <td className="text-right">
                        <b>
                          £
                          {Number(tippingObject.MoverTotal)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>    
  );
}

export default ContractorView;
